// 时间戳格式化
export function parseTime(time, cFormat) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string')) {
			if ((/^[0-9]+$/.test(time))) {
				// support "1548221490638"
				time = parseInt(time)
			} else {
				// support safari
				// https://stackoverflow.com/questions/4310953/invalid-date-in-safari
				time = time.replace(new RegExp(/-/gm), '/')
			}
		}

		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
		const value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') {
			return ['日', '一', '二', '三', '四', '五', '六'][value]
		}
		return value.toString().padStart(2, '0')
	})
	return time_str
}
// 性别格式化
export function sexInit(sex) {
	switch (Number(sex)) {
		case 1:
			return '男'
			break;
		case 2:
			return '女'
			break;
		case 0:
			return '保密'
			break;
	}
}
// 租售-招租 出租方式格式化
export function letTypeInit(type) {
	switch (Number(type)) {
		case 0:
			return '合租'
			break;
		case 1:
			return '整租'
			break;
	}
}
// 租售-招租 角色格式化
export function letRoleInit(role) {
	switch (Number(role)) {
		case 1:
			return '业主'
			break;
		case 2:
			return '中介'
			break;
	}
}
// 租售-招租 交租方式格式化
export function letPayMethodInit(type) {
	switch (Number(type)) {
		case 1:
			return '交付物业'
			break;
		case 2:
			return '平台代收'
			break;
	}
}
// 订单状态格式化
export function orderStateInit(state) {
	switch (Number(state)) {
		case 0:
			return '未支付'
			break;
		case 1:
			return '已支付'
			break;
		case 2:
			return '已发货'
			break;
		case 3:
			return '已收货'
			break;
		case 4:
			return '已评价'
			break;
		case 9:
			return '已关闭'
			break;
	}
}
// 配送方式格式化
export function deliveryInit(state) {
	switch (Number(state)) {
		case 1:
			return '快递'
			break;
		case 2:
			return '同城配送'
			break;
		case 3:
			return '到店自提'
			break;
	}
}
// 支付方式格式化
export function payTypeInit(state) {
	switch (Number(state)) {
		case 1:
			return '钱包'
			break;
		case 2:
			return '微信'
			break;
		case 3:
			return '支付宝'
			break;
	}
}
// 物流状态格式化
export function expressState(state) {
	switch (Number(state)) {
		case 1:
			return '待接单'
		break;
		case 2:
			return '待取货'
		break;
		case 3:
			return '配送中'
		break;
		case 4:
			return '已完成'
		break;
		case 5:
			return '已取消'
		break;
		case 8:
			return '指派单'
		break;
		case 9:
			return '妥投异常之物品返回中'
		break;
		case 10:
			return '妥投异常之物品返回完成';
		break;
		case 100:
			return '骑士到店';
		break;
		case 1000:
			return '创建达达运单失败';
		break;
	}
}
// 生成管理员的路由
export function createRoutes(asyncRoutes, data) {
	let routers = [];

	// for (var i = 0; i < asyncRoutes.length; i++) {
	// 	if(data.includes(asyncRoutes[i].path)){
	// 		routers[i] = asyncRoutes[i]

	// 	}
	// }
	asyncRoutes.forEach(item => {
		if (data.includes(item.path)) {
			let temp = item;
			temp.children2 = [];
			item.children.forEach(item2 => {
				if (data.includes(item2.path)) {
					temp.children2.push(item2);
				}
			})
			temp.children = temp.children2;
			delete temp.children2;
			routers.push(temp);
		}
	})
	return routers;
}
// 弹框
export function alertMsg(_this,msg,type_val="error"){
	return _this.$message({
		showClose: true,
		message: msg,
		type: type_val
	});
}